module.exports = __webpack_public_path__ + "img/03_LATON.3b0bbcbe.png";